/**
 * The sentence to show for a failed auth call: the server's own words, whichever shape carries them (`error` as a string, as the closed
 * sign-up 403 "Signups open soon" does, `error.message`, or `message`), else the request's message, else `fallback`.
 */
export function authErrorMessage(error: unknown, fallback: string): string {
  const e = error as { message?: string; response?: { data?: { error?: unknown; message?: unknown } } } | undefined;
  const data = e?.response?.data;
  const nested = (data?.error as { message?: unknown } | undefined)?.message;
  const pick = [typeof data?.error === 'string' ? data.error : null, typeof nested === 'string' ? nested : null, typeof data?.message === 'string' ? data.message : null, e?.message];
  return pick.find((m): m is string => typeof m === 'string' && m.length > 0) ?? fallback;
}
